export enum LanguageEnum {
  English = 'en',
  Korean = 'ko',
}

export enum SortEnum {
  Asc = 'asc',
  Desc = 'desc',
  Featured = 'featured',
}

export type DropDownSortItem = {
  value: SortEnum;
  label: string;
};
